import { Filter } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import type { DateFilter } from "@/features/reports/schemas/reports";
import type { User } from "@/features/users/schemas/user";

import { DateFilterSection } from "./DateFilterSection";

interface FiltersSectionProps {
  selectedUser: User | null;
  dateFilter: DateFilter;
  showCustomDate: boolean;
  onDateFilterChange: (type: DateFilter["type"]) => void;
  onCustomDateChange: (field: "startDate" | "endDate", value: string) => void;
  onApplyFilters: () => void;
  setShowData: (show: boolean) => void;
}

/**
 * Componente para la sección de filtros
 * @param {FiltersSectionProps} props - Las props del componente
 * @returns {React.JSX.Element} El componente FiltersSection
 */
export function FiltersSection({
  selectedUser,
  dateFilter,
  showCustomDate,
  onDateFilterChange,
  onCustomDateChange,
  onApplyFilters,
  setShowData,
}: FiltersSectionProps): React.JSX.Element {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Filter className="h-5 w-5" />
          Filtros
        </CardTitle>
        <CardDescription>Configura los filtros para el reporte</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col sm:flex-row gap-4 justify-evenly">
          <DateFilterSection
            setShowData={setShowData}
            dateFilter={dateFilter}
            showCustomDate={showCustomDate}
            onDateFilterChange={onDateFilterChange}
            onCustomDateChange={onCustomDateChange}
          />
        </div>
      </CardContent>
      <CardFooter className="flex justify-end">
        <Button
          onClick={onApplyFilters}
          disabled={!selectedUser || !dateFilter.type}
          className="w-full sm:w-auto"
        >
          Aplicar Filtros
        </Button>
      </CardFooter>
    </Card>
  );
}
